import React, { useCallback } from 'react';
import cn from 'classnames';
import { createFormField } from 'Shared/utils/createFormField';

import { GoalIcons } from 'Shared/constants/types';
import WPIcon from 'Wpds/components/icon/WpIcon';

import './FormIconPicker.scss';

type IconProps = {
  iconKey: any;
  selected?: boolean;
  onClick?: Function;
  readOnly?: boolean;
  size?: number;
  className?: string;
};

export function Icon({ iconKey, selected = false, onClick, readOnly = false, size = 38, className }: IconProps) {
  const handleClick = useCallback(() => {
    if (!readOnly && onClick) onClick(iconKey);
  }, [iconKey, onClick, readOnly]);

  return (
    <div
      style={{ width: size, height: size }}
      className={cn('goal-icon-picker-icon-wrapper', {
        'goal-icon-picker-icon-wrapper--selected': selected,
        [className]: true,
      })}
      onClick={handleClick}
    >
      <WPIcon name={iconKey} />
    </div>
  );
}

type IconPickerProps = {
  value: string;
  onChange: Function;
};

function FormIconPicker({ value, onChange }: IconPickerProps) {
  return (
    <div className="d-flex goal-form-icon-picker">
      {Object.values(GoalIcons).map(iconKey => (
        <Icon
          key={iconKey}
          iconKey={iconKey}
          className="goal-form-icon-picker-icon"
          selected={value === iconKey}
          onClick={onChange}
        />
      ))}
    </div>
  );
}

export default createFormField(FormIconPicker);
